import { Circle } from "@mui/icons-material";
import { Box, Typography } from "@mui/material";
import { ReactNode } from "react";

import { S } from "./chartTooltip.styles";

type SubHeader = {
    label: string;
    value?: ReactNode;
    iconColor?: string;
};

type SectionItem = {
    textColor?: string;
    fontSize?: number;
    fontWeight?: number | string;
} & SubHeader;

export type SectionProps = {
    header?: ReactNode;
    items?: SectionItem[];
    subHeaders?: SubHeader[];
};

const ChartTooltipSection = (props: SectionProps) => {
    const { header, subHeaders, items = [] } = props;

    const list = items
        .filter((item) => Boolean(item.value))
        .map((item, index) => {
            const { label, value, iconColor, textColor, fontSize, fontWeight } =
                item;

            return (
                <Box
                    key={`${label}-${index}`}
                    display="flex"
                    alignItems="center"
                    gap={1}
                    sx={{ my: 1 }}
                >
                    {iconColor && (
                        <Circle sx={{ fontSize: 10 }} htmlColor={iconColor} />
                    )}
                    <Box
                        display="flex"
                        gap={4}
                        justifyContent="space-between"
                        flexGrow="1"
                    >
                        <Typography
                            color={textColor ? textColor : "text.secondary"}
                            fontSize={fontSize}
                            fontWeight={fontWeight}
                        >
                            {label}
                        </Typography>
                        <Typography fontSize={fontSize} fontWeight={fontWeight}>
                            {value}
                        </Typography>
                    </Box>
                </Box>
            );
        });

    return (
        <Box px={5}>
            {header && <S.Header>{header}</S.Header>}
            {subHeaders?.map(({ label, value, iconColor }, index) => (
                <S.SubHeaderBox key={index}>
                    <Typography color="text.secondary">{label}:</Typography>
                    <S.SubHeader>
                        {iconColor && (
                            <Circle
                                sx={{ fontSize: 10, marginRight: 1 }}
                                htmlColor={iconColor}
                            />
                        )}
                        {value}
                    </S.SubHeader>
                </S.SubHeaderBox>
            ))}

            {list}
        </Box>
    );
};

export default ChartTooltipSection;
